import { create } from "zustand";

interface ILoginPopupAtom {
  showCustomLoginPopup: boolean;
  destination: string;
  toggleCustomLoginPopup: (showCustomLoginPopup: boolean) => void;
}

export const customLoginPopupAtom = create<ILoginPopupAtom>((set) => ({
  showCustomLoginPopup: false,
  destination: "",
  toggleCustomLoginPopup: (showPopup, destination = null) => {
    set(() => ({
      showCustomLoginPopup: showPopup,
        ...(destination && { destination }),
    }));
  },
}));
